<template>
    <div v-if="yellowCardWarning.isShow == 1" class="yellow-card-warning">违规黄牌警示
        <el-button style="margin-left: 20px;" type="text" @click="showTip">查看详情</el-button>
    </div>
</template>
<script>
export default {
    computed: {
        yellowCardWarning() {
            const isShow = this.$store.state.userInfo ? this.$store.state.userInfo.yellowCardWarning : 0;
            const text = this.$store.state.userInfo ? this.$store.state.userInfo.yellowCardWarningReason : ''
            return {
                isShow,
                text,
            }
        },
    },
    methods: {
        showTip() {
            this.$message.warning(this.yellowCardWarning.text);
        },
    }
};
</script>
<style lang="scss" scoped>
.yellow-card-warning {
    position: relative;
    background: #FFF0D3;
    line-height: 44px;
    font-weight: 500;
    font-size: 14px;
    color: #F8A126;
    padding: 0 20px 0 50px;
    text-align: left;

    &::before {
        content: "";
        position: absolute;
        background: url('~@/assets/img/yellow-card-warning.svg') no-repeat center;
        width: 22px;
        height: 22px;
        left: 20px;
        top: 10px;
    }
}
</style>
